import {dismissError} from '../util/errors';
import {
	logIn,
	unifiedLogIn,
	renewAuthentication,
	clearAuthenticationIfExpired,
	logOut,
} from './auth';

const globalDispatchToPropsObject: GlobalDispatchToPropsObject = {
	logIn,
	unifiedLogIn,
	renewAuthentication,
	clearAuthenticationIfExpired,
	logOut,
	dismissError,
};

export default globalDispatchToPropsObject;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/store/actions/global/index.ts